var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService } from '../baseService';
export class ScheduledAppointments extends BaseService {
    constructor(props) {
        super(props);
    }
    stat(params, options) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('scheduled_appointments.stat', params, options);
            return Object.assign(Object.assign({}, res), { preparedValue: res.prepared.stat
                    ? Object.assign(Object.assign({}, res.prepared.stat), { items: ((_b = (_a = res.prepared.stat) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.items) || [] }) : undefined });
        });
    }
    statProviders(params, options) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('scheduled_appointments.allowed_providers', params, options);
            return Object.assign(Object.assign({}, res), { preparedValue: {
                    providers: res.prepared.providers
                        ? Object.assign(Object.assign({}, res.prepared.providers), { items: ((_a = res.prepared.providers) === null || _a === void 0 ? void 0 : _a.items) || [] }) : undefined,
                } });
        });
    }
    create(params, options) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('scheduled_appointments.create', params, options);
            return Object.assign(Object.assign({}, res), { preparedValue: {
                    appointment: (_a = res.prepared) === null || _a === void 0 ? void 0 : _a.appointment
                } });
        });
    }
    findWindows(params, options) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            res = yield this.api.fetchLoggedV3('scheduled_appointments.find_staff', params, options);
            return Object.assign(Object.assign({}, res), { preparedValue: {
                    windows: res.prepared.windows
                        ? Object.assign(Object.assign({}, res.prepared.windows), { items: ((_b = (_a = res.prepared.windows) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.items) || [] }) : undefined,
                    staff: res.prepared.staff
                        ? Object.assign(Object.assign({}, res.prepared.staff), { items: ((_c = res.prepared.staff.items) === null || _c === void 0 ? void 0 : _c.items) || [] }) : undefined,
                } });
        });
    }
}
